import React from 'react';
import { Plane, Mail, MapPin, Phone } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-muted/50 border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center">
                <Plane className="w-6 h-6 text-primary-foreground" />
              </div>
              <span className="text-xl font-bold">UAVs For Sale</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              The Global Marketplace for Industrial Drones.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">Platform</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => navigate('/marketplace')} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Browse Marketplace
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/marketplace')} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Categories
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/sell')} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Sell Your Drone
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/')} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Pricing
                </button>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">Categories</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => navigate('/marketplace')} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Inspection
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/marketplace')} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Surveying
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/marketplace')} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Agriculture
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/marketplace')} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Cinematography
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-muted-foreground">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>info@uavsforsale.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-muted-foreground">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>+1 (555) 123-4567</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-muted-foreground">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>San Francisco, CA</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-border">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground">
              © {currentYear} UAVsForSale.com. The Global Marketplace for Industrial Drones.
            </p>
            <div className="flex gap-6">
              <button onClick={() => navigate('/privacy-policy')} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                Privacy Policy
              </button>
              <button onClick={() => navigate('/terms-of-service')} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                Terms of Service
              </button>
              <button onClick={() => navigate('/cookie-policy')} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                Cookie Policy
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}